module.exports = __webpack_public_path__ + "static/media/detail_avatar.5f09c36a.png";